import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-option',
  templateUrl: './dropdown-option.component.html',
  styleUrls: ['./dropdown-option.component.scss'],
})
export class DropdownOptionComponent {
  @Input() value: string = '';
  @Output() optionSelect = new EventEmitter();

  @HostListener('click')
  select() {
    this.optionSelect.emit(this.value);
  }
}
